
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/snohistorik",
      function () {
        return require("private-next-pages/[region]/[resort]/snohistorik.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/snohistorik"])
      });
    }
  